import { fieldRegistry } from './fieldRegistry';
import { imageFieldConfig } from './fields/imageFieldConfig';
import { audioFieldConfig } from './fields/audioFieldConfig';
import { titleFieldConfig } from './fields/titleFieldConfig';
import { descriptionFieldConfig } from './fields/descriptionFieldConfig';

export const registerDefaultFieldRenderers = () => {
  fieldRegistry.register('image', imageFieldConfig);
  fieldRegistry.register('audio', audioFieldConfig);
  fieldRegistry.register('input', titleFieldConfig);
  fieldRegistry.register('textarea', descriptionFieldConfig);
};

registerDefaultFieldRenderers();
